import http from "infra/http";
import { useMutation } from "react-query";

function useLerMensagem() {
  return useMutation(
    (id: string) => {
      return http.post(`/v1/mensagem/${id}/ler`);
    },
    { retry: false }
  );
}

export default useLerMensagem;
